module.exports = __webpack_public_path__ + "static/media/btn_bookmark_off.bdc2bc15.svg";